import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100%',
  },
  hasDecorative: {
    overflow: 'visible',
  },
  content: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(5),
    },
  },
  avatarWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.lighter,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
    },
  },
  decorative: {
    display: 'none',
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(6),
    [theme.breakpoints.up('lg')]: {
      display: 'block',
    },
  },
}))

export default useStyles
